import { render } from "./ChartDemo.vue?vue&type=template&id=64083c09"
import script from "./ChartDemo.vue?vue&type=script&lang=js"
export * from "./ChartDemo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/amee/iptu-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__